'use strict';

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _asyncToGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var CID = require('cids');

var multipartRequest = require('../../lib/multipart-request');

var configure = require('../../lib/configure');

var toUrlSearchParams = require('../../lib/to-url-search-params');

var abortSignal = require('../../lib/abort-signal');

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;
/**
 * @typedef {import('../../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/object/patch').API<HTTPClientExtraOptions>} ObjectPatchAPI
 */


module.exports = configure(function (api) {
  /**
   * @type {ObjectPatchAPI["setData"]}
   */
  function setData(_x, _x2) {
    return _setData.apply(this, arguments);
  }

  function _setData() {
    _setData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, data) {
      var options,
          controller,
          signal,
          _yield$yield$api$post,
          Hash,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              // allow aborting requests on body errors
              controller = new AbortController();
              signal = abortSignal(controller.signal, options.signal); // @ts-ignore https://github.com/ipfs/js-ipfs-utils/issues/90

              _context.t0 = api;
              _context.t1 = _objectSpread;
              _context.t2 = {
                timeout: options.timeout,
                signal: signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: ["".concat(cid instanceof Uint8Array ? new CID(cid) : cid)]
                }, options))
              };
              _context.next = 8;
              return multipartRequest(data, controller, options.headers);

            case 8:
              _context.t3 = _context.sent;
              _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
              _context.next = 12;
              return _context.t0.post.call(_context.t0, 'object/patch/set-data', _context.t4);

            case 12:
              _context.next = 14;
              return _context.sent.json();

            case 14:
              _yield$yield$api$post = _context.sent;
              Hash = _yield$yield$api$post.Hash;
              return _context.abrupt("return", new CID(Hash));

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _setData.apply(this, arguments);
  }

  return setData;
});